module.exports = __webpack_public_path__ + "static/media/sunglasses.4b0304fb.svg";